export const SET_PICKUP_ADDRESS = '[Pickup Address] Set Pickup Address';
export const HANDLE_PICKUPADDRESS_FORM_CHANGE = '[Pickup Address] Handle changes in the form';
export const GET_GEOSUGGEST_ADDRESS  = '[Pickup Address] Get Geosuggest Address';
export const FETCH_GEOSUGGEST_ADDRESS_SUCCESS = '[Pickup Address] Geosuggest Address Fetch Success';
export const FETCH_GEOSUGGEST_ADDRESS_ERROR = '[Pickup Address] Geosuggest Address Fetch Error';
export const SET_GEOSUGGEST_ADDRESS = '[Pickup Address] Set Geosuggest Address';
export const COPY_GEOSUGGEST_ADDRESS = '[Pickup Address] Copy Geosuggest Address to Pickup Address';
export const SET_PICKUPADDRESS_TO_LOT = '[Pickup Address] Set Pickup Address to lot Details';
export const CHECK_ZIP_VALIDITY = '[Pickup Address] Check if the zip is valid';
export const ON_AUTOFILL_SELECT = '[Pickup Address] Selected autofill address from addressline1';
export const ON_SUGGEST_ADDRESS_BLUR = '[Pickup Address] on addressline1 blur';
export const SET_SUGGESTADDRESS = '[Pickup Address] Set suggest address from server';
export const PICKUPADDRESS_FORM_SUBMISSION = '[Pickup Address] Submit Address Form';
export const UPDATE_PICKUPADDRESS = '[Pickup Address] Update Pickup Address';
export const SET_ADDRESS_ERRORS = '[Pickup Address] Update Pickup Address Errors';
export const CHECK_ADDRESS_EDIT_FLAG = '[Pickup Address] Set edit address flag to true';

export const onAddressFormChange = (data) => ({
  type: HANDLE_PICKUPADDRESS_FORM_CHANGE,
  payload: data
});

export const onAutoFillSelect = (data) => ({
  type: ON_AUTOFILL_SELECT,
  payload: data
});


export const onSuggestAddressBlur = (data) => ({
  type: ON_SUGGEST_ADDRESS_BLUR,
  payload: data
});

export const copySuggestAddress = () => ({
  type: COPY_GEOSUGGEST_ADDRESS
});

export const checkAddressEditFlag = () => ({
  type: CHECK_ADDRESS_EDIT_FLAG
});



// WEBPACK FOOTER //
// ./src/redux/actions/address.js